module.exports = __webpack_public_path__ + "static/img/logo14.194c420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo14.png
// module id = D3dl
// module chunks = 2